/* eslint-disable max-lines */
/**
 * 菜单按钮权限配置文件
 */
const systemManagement = {
    'organizationMaintain': {
        edit: '100013001',
        maintenance: '100013002'
    },
    'companyMaintain': {
        add: '100014001',
        edit: '100014002',
        sync: '100014003',
        companyChang: '100014004',
        export: '100014005'
    },
    'sysCtrlParam': {
        add: '100001001',
        examine: '100001002',
        edit: '100001003',
        delete: '100001004'
    },
    'databaseManage': {
        add: '100002001',
        switchStatus: '100002002',
        manage: '100002004',
        edit: '100002005',
        delete: '100002006'
    },
    'dataInstanceManage': {
        add: '100003001',
        switch: '100003002'
    },
    'dataDictionary': {
        add: '100004001',
        sync: '0104000001',
        skipDetail: '100004003',
        edit: '100004004',
        delete: '100004005'
    },
    'mqManager': {
        add: '100005001',
        edit: '100005002',
        delete: '100005003',
        siwtchOn: '100005004',
        siwtchOff: '100005005'
    },
    'consumerMange': {
        Edit: '0602000001',
        apiConfig: '0602000002',
        checkDaily: '0602000003',
        handleDelete: '0602000004',
        siwtchOff: '0602000005',
        add: '0602000006',
        retry: '0602000007'
    },
    'mappingSync': {
        add: '100007001',
        syncEdit: '100007002',
        customSync: '100007003',
        view: '100007004',
        valueSync: '100007005'
    },
    'translationTable': {
        export: '100008001',
        edit: '100008002',
        batchSave: '100008003'
    },
    'translationDataDictionary': {
        import: '100009001',
        export: '100009002',
        edit: '100009003',
        batchSave: '100009004'
    },
    'masterDataTranslation': {
        import: '100010001',
        export: '100010002',
        edit: '100010003',
        batchSave: '100010004'
    }
};
const warehouseRelated = {};
const commodityRelated = {};
const addressRelated = {
    'addressMapping': {
        add: '0704000001',
        batchSave: '0704000002',
        delete: '0704000003'
    },
    'admLayout': {
        add: '700003001',
        calibration: '700003002',
        revise: '700003003'
    }

};
const exportSales = {
    'orgFramework': {
        add: '146600010',
        edit: '146600011',
        revise: '146600012'
    },
    'physicsWarehouse': {
        add: '12500670001',
        edit: '12500670002',
        delete: '12500670003',
        sync: '12500670004'
    },
    'loadAndUnloadGroup': {
        add: '12500680001',
        edit: '12500680002',
        delete: '12500680003',
        sync: '12500680004'
    },
    'sublibraryOrganization': {
        add: '12210002001',
        import: '12210002002',
        batchSave: '12210002003',
        batchEnable: '12210002004',
        batchDisable: '12210002005'
    },
    'sublibraryMerchandise': {
        add: '12210003001',
        batchSave: '12210003002',
        batchEnable: '12210003003',
        batchDisable: '12210003004',
        import: '12210003005'
    },
    'exportSalesOrderType': {
        add: '12210004001',
        batchSave: '12210004002',
        batchEnable: '12210004003',
        batchDisable: '12210004004'
    },
    'exportSalesOrderTypeMapping': {
        add: '12210005001',
        batchSave: '12210005002',
        batchEnable: '12210005003',
        batchDisable: '12210005004'
    }
};
const baseFunction = {};
const customerRelated = {
    'tianfuBankContract': {
        detailSave: '0606000001',
        detailApplyIflow: '0606000002',
        detailUploadFilesToTF: '0606000003',
        detailFilesTableAdd: '0606000004',
        detailUploadFilesToZHQ: '0606000005'
    },
    'contractManage': {
        rateAddPrivilege: '0707000001', // 子页签费率明细特权新增
        rateSavePrivilege: '0707000002', // 子页签费率明细特权保存
        rateDeletePrivilege: '0707000003', // 子页签费率明细特权删除
        priceMaintain: '0707000004', // 主合同计费模型和价格
        importPriceDetailS: '0707000005', // 价格表明细-特权导入明细
        deletePriceDetailS: '0707000006', // 价格表明细-特权删除价格表
        addPriceDetailS: '0707000007', // 价格表-特权新增
        openPriceDetailS: '0707000008', // 价格表-特权启用
        addNewMain: '0707000009', // 主合同新增
        deleteMain: '0707000010', // 主合同删除
        exportMain: '0707000011', // 主合同导出
        saveMain: '0707000012', // 主合同保存
        applyIflow: '0707000013', // 主合同提交审批
        replenishContract: '0707000014', // 主合同补充协议
        stopContract: '0707000015', // 主合同终止协议
        otherChange: '0707000016', // 主合同其他变更
        contractChangeSubmit: '0707000017', // 主合同变更提交
        contractApproved: '0707000018', // 主合同审批通过
        contractApprovedReject: '0707000019', // 主合同审批驳回
        // priceMaintenBtn: '0707000020', // 主合同计费模型和价格
        subAddNewFile: '0707000021', // 子页签附件明细新增
        subDeleteFile: '0707000022', // 子页签附件明细删除
        subAddNewCustomer: '0707000023', // 子页签客户明细新增
        subSaveCustomer: '0707000024', // 子页签客户明细保存
        subDeleteCustomer: '0707000025', // 子页签客户明细删除
        subImportCustomer: '0707000026', // 子页签客户明细导入
        subExportCustomer: '2024082268', // 子页签客户明细-导出
        subAddNewCompany: '0707000027', // 子页签分公司明细新增
        subDeleteCompany: '0707000028', // 子页签分公司明细删除
        subAddSiteCompany: '0707000029', // 子页签分公司明细新增服务平台
        subDeleteSiteCompany: '0707000030', // 子页签分公司明细删除服务平台
        subAddNewRate: '0707000031', // 子页签业务税率新增
        subSaveRate: '0707000032', // 子页签业务税率保存
        subDeleteRate: '0707000033', // 子页签业务税率删除
        subAddNewPrescreen: '0707000034', // 子页签预签明细新增
        subSavePrescreen: '0707000035', // 子页签预签明细保存
        subDeletePrescreen: '0707000036', // 子页签预签明细删除
        subDeleteOtherChange: '0707000037', // 子页签其他变更明细删除
        subAddNewOil: '0707000038', // 子页签油价信息新增
        subSaveOil: '0707000039', // 子页签油价信息保存
        subDeleteOil: '0707000040', // 子页签油价信息删除
        addNewPriceMain: '0707000041', // 价格表-新增
        exportPlacePriceMain: '0707000042', // 价格表-导出行政规则
        importPriceDetail: '0707000043', // 价格表明细-导入明细
        exportPriceDetail: '0707000044', // 价格表明细-导出明细
        clearPriceDetail: '0707000045', // 价格表明细-清空草稿明细
        deletePriceDetail: '0707000046', // 价格表-删除
        addNewPriceMainMD: '0707000047', // 价格表-产品中台新增
        subAddNewOpportunity: '0707000048', // 子页签分公司明细-新增商机
        subFileView: '0707000049', // 子页签-附件明细-预览
        subFileDownLoad: '0707000050', // 子页签-附件明细-下载
        subFileUpLoad: '0707000051', // 子页签-附件明细-上传
        subAddNewCompanyS: '0707000052', // 子页签分公司明细新增(CRM合同管理专员角色独有)
        subPushPrice: '0707000053', // 价格表-推送合同价格
        otherChangeBasic: '0707000054', // 主合同-其他变更-基本信息
        otherChangeDate: '0707000055', // 主合同-其他变更-合同日期
        otherChangePrice: '0707000056', // 主合同-其他变更-价格信息
        changeStandard: '0707000057', // 主合同-转标准产品合同
        subAddNewCompanyBatch: '0707000058', // 子页签-分公司明细-批量更新分公司
        contractArchive: '0707000059', // 合同归档
        contractArchivePrint: '0707000060', // 打印归档码
        subAddNewFileBatch: '0707000061', // 子页签-附件明细-批量更新附件
        subAddNewOpportunityPrivilege: '0707000062', // 子页签分公司明细-特权新增商机
        subDeleteCompanyPrivilege: '0707000063', // 子页签分公司明细-特权删除
        subAddSiteCompanyBatch: '0707000064', // 子页签分公司明细-批量添加服务平台
        subAddSiteCompanyPrivilege: '0707000065', // 子页签分公司明细-特权添加服务平台
        subDeleteSiteCompanyPrivilege: '0707000066', // 子页签分公司明细-特权删除服务平台
        subFlowAbandom: '2024080167', // 子页签分公司明细-特权删除服务平台
        otherSignature: '2025021368', // 主合同-提交第三方签章
        anntoSignature: '2025021369', // 主合同-提交智汇签验签
        contractSource: '2025062614', // 主合同-编辑合同来源
        exportMainNew: '2025072416', // 主合同-新运维导出
        subAddNewPrivilegeCustomer: '2025090414', // 主合同--客户明细-特权新增
        subSavePrivilegeCustomer: '2025090415' // 主合同--客户明细-特权保存
    },
    'contractGroupManage': { // 合同组管理
        addBatch: '1000000001',
        replenishBatch: '1000000002',
        stopBatch: '1000000003',
        delete: '1000000004',
        save: '1000000005',
        submitMip: '1000000006',
        addContractList: '1000000007',
        pushContractFW: '1000000008',
        saveContractList: '1000000009',
        deleteContractList: '10000000010'
    },
    'accountManage': {
        addNew: '0808000001', // 新增-按钮
        generate: '0808000002', // 生成账号-按钮
        enable: '0808000003', // 启用-按钮
        disable: '0808000004', // 停用-按钮
        export: '0808000005' // 导出-按钮
    },
    'biddingAccountManage': {
        discard: '202601291659', // 废弃
        enable: '202601291700', // 启动
        import: '202601291701', // 导入
        export: '202601291702', // 导出
        edit: '202601291703', // 编辑
        add: '202601291704', // 新增
        save: '202601291705' // 保存
    },
    'contractArchive': {
        stop: '1100000001', // 停用
        export: '1100000002' // 导出
    },
    'contractView': {
        priceSubtab: '1200000001' // 价格表子页签权限
    },
    'contractRegistration': { // 续签合同登记表
        save: '1400000001',
        export: '1400000002',
        import: '1400000003',
        exitReport: '2025040310',
        add: '202505151351',
        delete: '202505151352',
        newExport: '202506121809',
        edit: '202507301046',
        dataDelFlow: '202512041506' // 数据删除流程
    },
    'customer': {
        subStamperUse: '2024091910',
        subStamperStop: '2024091911',
        subStamperSync: '2024091912',
        subStamperLink: '2024091913',
        subStamper: '2024091914',
        subEcba: '2024111109',
        subEcbaAdd: '2024111110',
        subEcbaDel: '2024111111',
        subEcbaPush: '2024111112',
        subEcbaConfirm: '2024111113'
    },
    'customerManage': {
        add: '202509250949',
        export: '202509250950',
        // risk: '202509250952',
        legalPerson: '202509251554', // 法人
        noLegalPerson: '202509251555', // 非法人
        overseas: '202511200926', // 海外/港澳台注册
        useFlow: '202511201035', // 白名单启用
        stopFlow: '202511201036', // 白名单停用
        save: '202509251556', // 保存
        flow: '202509251557',
        infoChange: '202509251558',
        statusChange: '202509251559',
        supplier: '202509251560',
        virtual: '202509251561',
        group: '202509251562',
        law: '202509251563',
        icbu: '202509251564',
        risk: '202509251565',
        unlock: '202509251566',
        privilege: '202509251567',
        contactTab: '202509251568',
        contactAdd: '202509251569',
        contactSave: '202509251570',
        contactDel: '202509251571',
        stamperTab: '202509251572',
        subStamperUse: '202509251573',
        subStamperStop: '202509251574',
        subStamperSync: '202509251575',
        subStamperLink: '202509251576',
        ebcaTab: '202509251577',
        virtualTab: '202510301135',
        subEcbaAdd: '202509251578',
        subEcbaDel: '202509251579',
        subEcbaConfirm: '202509251580',
        subEcbaPush: '202509251581',
        subEcbaRefresh: '202509251582',
        contractTab: '202509251583',
        iflowDetailTab: '202509251584',
        historyTab: '202509251585',
        xsyPush: '202509251586',
        xsyLink: '202509251587',
        iflowDetailDel: '202510301136',
        overseasIntroduction: '202511131127',
        overseasIntroductionTab: '202511131141',
        subOverseasIntroductionAdd: '202511131142',
        subOverseasIntroductionDelete: '202511131143',
        subOverseasIntroductionFlow: '202511131157',
        subOverseasIntroductionConfirm: '202511131144',
        addPaper: '202512111423',
        erpBtn: '202512251438',
        subEcbaInvalidPush: '202512251439',
        showConfirmButton: '202501251906', // 确认按钮权限
        biddingAccountTab: '202602291613'
    },
    'customerPersonResponsible': { // 客户责任人归档表
        addNew: '1300000001',
        save: '1300000002',
        delete: '1300000003',
        export: '1300000004',
        edit: '202505081419',
        incomeSharing: '202505291647',
        transfer: '202507300950'
    },
    'customerPersonResponsibleData': {
        add: '202512270001',
        edit: '202512270002',
        delete: '202512270003',
        verify: '202512270004',
        export: '202512270005',
        upload: '202512270006'
    },
    'companyManagerArchive': {
        export: '1500000001'
    },
    'opportunity': { // 商机模块
        opportunityListExport: '1600000001', // 商机表导出
        opportunityTransfer: '202512251556' // 转移
    },
    'organization': {
        add: '202601150001',
        edit: '202601150002',
        delete: '202601150003',
        editUser: '202601150004',
        export: '202601150005',
        disabled: '202601150006',
        enabled: '202601150007'
    },
    'organizationLog': {
        process: '202601150008',
        agree: '202601150009',
        ignore: '2026011500010'
    },
    'customerGroup': { // 集团客户模块
        export: '2024112814' // 导出
    },
    'revenueForecast': {
        import: '202505151634',
        export: '202505151635',
        addNew: '202505290910',
        refresh: '202507101033',
        delete: '202507101451',
        edit: '202510161458',
        professionalCompany: '202510161459',
        role: '202510161460'
    },
    'customerIntroduction': {
        add: '202512081132',
        export: '202512081133',
        delete: '202512081134',
        approval: '202512081135'
    },
    'revenueVersion': {
        add: '202512040001',
        edit: '202512040002',
        save: '202512040003',
        verify: '202512040004'
    },
    'revenueFactor': {
        add: '202512040005',
        edit: '202512040006',
        save: '202512040007',
        enable: '202512040008',
        disable: '202512040009',
        export: '202512040010'
    },
    'customerVisitManage': {
        edit: '202501221449',
        import: '202501221450',
        useBatch: '202501221451',
        delete: '202501221452',
        export: '202501221453'
    }
};
const transportRelated = {
    'line': {
        add: '090400001',
        search: '090400002',
        export: '090400003',
        import: '090400004',
        edit: '090400005',
        enable: '090400006',
        disable: '090400007',
        distance: '090400008'
    },
    'carInspectionConfig': {
        add: '090600001',
        edit: '090600002',
        enable: '090600003',
        disable: '090600004'
    },
    'warehouseNetworkPlanning': {
        export: '091400101',
        import: '091400102',
        delete: '091400103',
        batchSave: '091400104',
        batchEnable: '091400105',
        batchDisable: '091400106',
        add: '091400107'
    }
};
const mappingControl = {
    'customerMapping': {
        add: '0901000001',
        batchSave: '0901000002',
        batchEnable: '0901000003',
        batchDisable: '0901000004',
        import: '0901000005'
    },
    'itemMapping': {
        add: '0902000001',
        batchSave: '0902000002',
        batchEnable: '0902000003',
        batchDisable: '0902000004'
    },
    'itemStatusMapping': {
        add: '0903000001',
        batchSave: '0903000002',
        batchEnable: '0903000003',
        batchDisable: '0903000004',
        import: '0903000005'
    },
    'warehouseMapping': {
        add: '0904000001',
        batchSave: '0904000002',
        batchEnable: '0904000003',
        batchDisable: '0904000004',
        import: '0904000005'
    },
    'orderTypeMapping': {
        add: '0905000001',
        batchSave: '0905000002',
        batchEnable: '0905000003',
        batchDisable: '0905000004'
    },
    'carrierMapping': {
        add: '0906000001',
        batchSave: '0906000002',
        batchEnable: '0906000003',
        batchDisable: '0906000004',
        import: '0906000005'
    },
    'warehouseSupplierMapping': {
        add: '0912000001',
        batchSave: '0912000002',
        batchEnable: '0912000003',
        batchDisable: '0912000004'
    },
    'upAndDownOrderTypeMapping': {
        add: '0907000001',
        batchSave: '0907000002',
        batchEnable: '0907000003',
        batchDisable: '0907000004'
    },
    'upAndDownWarehouseMapping': {
        add: '0908000001',
        batchSave: '0908000002',
        batchEnable: '0908000003',
        batchDisable: '0908000004'
    },
    'thirdPartyProviderMapping': {
        add: '0909000001',
        batchSave: '0909000002',
        batchEnable: '0909000003',
        batchDisable: '0909000004'
    }
};
const consumerMange = {
    'consumerMange': {
        Edit: '0602000001',
        apiConfig: '0602000002',
        checkDaily: '0602000003',
        handleDelete: '0602000004',
        siwtchOff: '0602000005',
        add: '0602000006',
        retry: '0602000007'
    }
};
const orderControl = {
    'receiveShippingContact': {
        import: '06280134001'
    }
};
const rulesRelated = {};
const internationalLogistics = {
    'port': {
        add: '130001001',
        export: '130001002',
        import: '130001003',
        col: '130001004',
        edit: '130001005'
    }
};
const midrangeArchitecture = {
    'orderNumble': {
        add: '1101000001',
        batchSave: '1101000002',
        batchEnable: '1101000003',
        batchDisable: '1101000004'
    }
};

const clientData = {
    'clientMapping': {
        add: '1201000001',
        batchSave: '1201000002',
        batchEnable: '1201000003',
        batchDisable: '1201000004',
        import: '1201000005'
    },
    'clientGroup': {
        add: '1202000001',
        edit: '1202000002'
    },
    'clientList': {
        add: '1203000001',
        batchSave: '1203000002',
        batchEnable: '1203000003',
        batchDisable: '1203000004',
        sync: '1203000005'
    },
    'clientDictionarie': {
        add: '1204000001',
        batchSave: '1204000002',
        batchEnable: '1204000003',
        batchDisable: '1204000004'
    }
};

const customerManager = {
    'repaymentPlan': {
        importBtn: '202512111648',
        exportBtn: '202512111649',
        saveBtn: '202512111650',
        lock: '202512111651',
        unlock: '202512111652',
        editBtn: '202512111653'
    }
};

const pendingManager = {
    'renewalPending': {
        export: '202601211551'
    },
    'renewalEdit': {
        edit: '202602021718'
    }
};
const targetModules = {
    'monthProgressReport': {
        import: '20260106001',
        export: '20260106002',
        delete: '20260106003'
    },
    'monthRulesConfigurationSheet': {
        import: '20260106004',
        export: '20260106005',
        delete: '20260106006'
    },
    'submissionApplication': {
        add: '20260106007',
        export: '20260106008',
        verity: '20260106009'
    },
    'mainReport': {
        import: '20260106010',
        export: '20260106011',
        delete: '20260106022'
    },
    'groupKpiReport': {
        import: '20260106012',
        export: '20260106013',
        delete: '20260106014'
    },
    'kpiReport': {
        import: '20260106015',
        export: '20260106016',
        delete: '20260106017'
    },
    'typeReport': {
        add: '20260106018',
        edit: '20260106019',
        save: '20260106020',
        export: '20260106021'
    }
};

const leadManager = {
    'leadImportList': {
        importBtn: '202601131648',
        exportBtn: '202601131650',
        generateBtn: '202601131652',
        abandonedBtn: '202601131655'
    }
};

export default {
    ...exportSales,
    ...consumerMange,
    ...systemManagement,
    ...warehouseRelated,
    ...commodityRelated,
    ...addressRelated,
    ...baseFunction,
    ...customerRelated,
    ...transportRelated,
    ...mappingControl,
    ...orderControl,
    ...internationalLogistics,
    ...rulesRelated,
    ...midrangeArchitecture,
    ...clientData,
    ...customerManager,
    ...pendingManager,
    ...targetModules,
    ...leadManager
};
